import styled from "styled-components";

export const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const CustomSelect = styled.select<{ $hasError?: boolean }>`
  width: 100%;
  height: 46px;
  padding: 0 24px;
  border: 1px solid ${({ $hasError }) => ($hasError ? "var(--formError)" : "var(--gray)")};
  border-radius: 8px;
  font-size: 16px;
  color: var(--dark-gray);
  background-color: var(--white);
  outline: none;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;

  &:focus {
    border-color: ${({ $hasError }) => ($hasError ? "var(--formError)" : "var(--fixit)")};
  }

  &:disabled {
    background-color: #efefef;
    cursor: not-allowed;
    color: var(--dark-gray);
    opacity: 0.9;
  }
`;

export const SelectLabel = styled.span<{ $hasError?: boolean; $isFocused?: boolean; $hasValue?: boolean }>`
  position: absolute;
  top: ${({ $isFocused, $hasValue }) => ($isFocused || $hasValue ? "-7px" : "16px")};
  left: ${({ $isFocused, $hasValue }) => ($isFocused || $hasValue ? "12px" : "24px")};
  margin-left: ${({ $isFocused, $hasValue }) => ($isFocused || $hasValue ? "20px" : "0")};
  background: ${({ $isFocused, $hasValue }) => ($isFocused || $hasValue ? "var(--white)" : "transparent")};
  padding: 0 6px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: ${({ $hasError, $isFocused, $hasValue }) => 
    $hasError 
      ? "var(--formError)" 
      : ($isFocused || $hasValue ? "var(--fixit)" : "#989898")
  };
  pointer-events: none;
  transition: all 0.5s ease;

  ${({ $isFocused, $hasValue }) =>
    ($isFocused || $hasValue) &&
    `
      left: 0px;
      transform: scale(0.75);
      transform-origin: left;
    `};
  
  z-index: 1;
`;

export const ErrorMessage = styled.div`
  display: flex;
  justify-content: flex-start;
  font-size: 12px;
  color: var(--formError);
  margin-top: 4px;
`;
